'use strict';

var React = require('react');
var optimizely = require('@optimizely/optimizely-sdk');
var hoistNonReactStatics = require('hoist-non-react-statics');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);
var optimizely__namespace = /*#__PURE__*/_interopNamespaceDefault(optimizely);

/**
 * Copyright 2018-2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OptimizelyContext = React.createContext({
    optimizely: null,
    isServerSide: false,
    timeout: 0,
});
var OptimizelyContextConsumer = OptimizelyContext.Consumer;
var OptimizelyContextProvider = OptimizelyContext.Provider;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Copyright 2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function areUsersEqual(user1, user2) {
    if (user1.id !== user2.id) {
        return false;
    }
    var user1Attributes = user1.attributes || {};
    var user2Attributes = user2.attributes || {};
    var user1Keys = Object.keys(user1Attributes);
    var user2Keys = Object.keys(user2Attributes);
    if (user1Keys.length !== user2Keys.length) {
        return false;
    }
    for (var _i = 0, user1Keys_1 = user1Keys; _i < user1Keys_1.length; _i++) {
        var key = user1Keys_1[_i];
        if (user1Attributes[key] !== user2Attributes[key]) {
            return false;
        }
    }
    return true;
}
function hoistStaticsAndForwardRefs(Target, Source, displayName) {
    // Make sure to hoist statics and forward any refs through from Source to Target
    // From the React docs:
    //   https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    //   https://reactjs.org/docs/forwarding-refs.html#forwarding-refs-in-higher-order-components
    var forwardRef = function (props, ref) { return React__namespace.createElement(Target, __assign({}, props, { forwardedRef: ref })); };
    forwardRef.displayName = "".concat(displayName, "(").concat(Source.displayName || Source.name, ")");
    return hoistNonReactStatics(React__namespace.forwardRef(forwardRef), Source);
}
function coerceUnknownAttrsValueForComparison(maybeAttrs) {
    if (typeof maybeAttrs === 'object' && maybeAttrs !== null) {
        return maybeAttrs;
    }
    return {};
}
/**
 * Equality check applied to override user attributes passed into hooks. Used to determine when we need to recompute
 * a decision because a new set of override attributes was passed into a hook.
 * @param {UserAttributes|undefined} oldAttrs
 * @param {UserAttributes|undefined} newAttrs
 * @returns boolean
 */
function areAttributesEqual(maybeOldAttrs, maybeNewAttrs) {
    var oldAttrs = coerceUnknownAttrsValueForComparison(maybeOldAttrs);
    var newAttrs = coerceUnknownAttrsValueForComparison(maybeNewAttrs);
    var oldAttrsKeys = Object.keys(oldAttrs);
    var newAttrsKeys = Object.keys(newAttrs);
    if (oldAttrsKeys.length !== newAttrsKeys.length) {
        // Different attr count - must update
        return false;
    }
    return oldAttrsKeys.every(function (oldAttrKey) {
        return oldAttrKey in newAttrs && oldAttrs[oldAttrKey] === newAttrs[oldAttrKey];
    });
}
function createFailedDecision(flagKey, message, user) {
    return {
        enabled: false,
        flagKey: flagKey,
        ruleKey: null,
        variationKey: null,
        variables: {},
        reasons: [message],
        userContext: {
            id: user.id,
            attributes: user.attributes,
        },
    };
}
function sprintf(format) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var i = 0;
    return format.replace(/%s/g, function () {
        var arg = args[i++];
        var type = typeof arg;
        if (type === 'function') {
            return arg();
        }
        else if (type === 'string') {
            return arg;
        }
        else {
            return String(arg);
        }
    });
}

/**
 * Copyright 2022, 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Notifier = /** @class */ (function () {
    function Notifier() {
        this.observers = [];
    }
    Notifier.getInstance = function () {
        if (!Notifier.instance) {
            Notifier.instance = new Notifier();
        }
        return Notifier.instance;
    };
    Notifier.prototype.subscribe = function (key, callback) {
        var _this = this;
        var subscriptionId = "key-".concat(Math.floor(100000 + Math.random() * 999999));
        this.observers.push({ subscriptionId: subscriptionId, key: key, callback: callback });
        return function () {
            var observerIndex = _this.observers.findIndex(function (observer) { return observer.subscriptionId === subscriptionId; });
            if (observerIndex >= 0) {
                _this.observers.splice(observerIndex, 1);
            }
        };
    };
    Notifier.prototype.notify = function (key) {
        this.observers.filter(function (observer) { return observer.key === key; }).forEach(function (observer) { return observer.callback(); });
    };
    return Notifier;
}());
var notifier = Notifier.getInstance();

/**
 * Copyright 2022, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logHandler = optimizely__namespace.getLogger('ReactSDK');
var logger$2 = {
    warn: function (msg) {
        var splat = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            splat[_i - 1] = arguments[_i];
        }
        return logHandler.log(optimizely__namespace.enums.LOG_LEVEL.WARNING, sprintf.apply(void 0, __spreadArray([msg], splat, false)));
    },
    info: function (msg) {
        var splat = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            splat[_i - 1] = arguments[_i];
        }
        return logHandler.log(optimizely__namespace.enums.LOG_LEVEL.INFO, sprintf.apply(void 0, __spreadArray([msg], splat, false)));
    },
    debug: function (msg) {
        var splat = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            splat[_i - 1] = arguments[_i];
        }
        return logHandler.log(optimizely__namespace.enums.LOG_LEVEL.DEBUG, sprintf.apply(void 0, __spreadArray([msg], splat, false)));
    },
    error: function (msg) {
        var splat = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            splat[_i - 1] = arguments[_i];
        }
        return logHandler.log(optimizely__namespace.enums.LOG_LEVEL.ERROR, sprintf.apply(void 0, __spreadArray([msg], splat, false)));
    },
};

/**
 * Copyright 2019-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NotReadyReason;
(function (NotReadyReason) {
    NotReadyReason["TIMEOUT"] = "TIMEOUT";
    NotReadyReason["NO_CLIENT"] = "NO_CLIENT";
    NotReadyReason["USER_NOT_READY"] = "USER_NOT_READY";
})(NotReadyReason || (NotReadyReason = {}));
var REACT_SDK_CLIENT_ENGINE = 'react-sdk';
var REACT_SDK_CLIENT_VERSION = '3.2.2';
var DefaultUser = {
    id: null,
    attributes: {},
};
var DEFAULT_ON_READY_TIMEOUT = 5000;
var OptimizelyReactSDKClient = /** @class */ (function () {
    /**
     * Creates an instance of OptimizelyReactSDKClient.
     * @param {optimizely.Config} [config={}]
     */
    function OptimizelyReactSDKClient(config) {
        var _this = this;
        this.userContext = null;
        this.onUserUpdateHandlers = [];
        this.isUserPromiseResolved = false;
        // Its usually true from the beginning when user is provided as an object in the `OptimizelyProvider`
        // This becomes more significant when a promise is provided instead.
        this.isUserReady = false;
        this.onForcedVariationsUpdateHandlers = [];
        this.forcedDecisionFlagKeys = new Set();
        // Is the javascript SDK instance ready.
        this.isClientReady = false;
        // We need to add autoupdate listener to the hooks after the instance became fully ready to avoid redundant updates to hooks
        this.clientAndUserReadyPromiseFulfilled = false;
        this.isUsingSdkKey = false;
        this.user = __assign({}, DefaultUser);
        this.initialConfig = config;
        var configWithClientInfo = __assign(__assign({}, config), { clientEngine: REACT_SDK_CLIENT_ENGINE, clientVersion: REACT_SDK_CLIENT_VERSION });
        this.userPromiseResolver = function () { };
        var userReadyPromise = new Promise(function (resolve) {
            _this.userPromiseResolver = resolve;
        });
        this._client = optimizely__namespace.createInstance(configWithClientInfo);
        this.isClientReady = !!configWithClientInfo.datafile;
        this.isUsingSdkKey = !!configWithClientInfo.sdkKey;
        if (this._client) {
            var clientReadyPromise = this._client.onReady();
            this.clientAndUserReadyPromise = Promise.all([userReadyPromise, clientReadyPromise]).then(function (_a) {
                var userResult = _a[0], clientResult = _a[1];
                _this.isClientReady = clientResult.success;
                _this.isUserReady = userResult.success;
                var clientAndUserReady = _this.isClientReady && _this.isUserReady;
                _this.clientAndUserReadyPromiseFulfilled = true;
                return {
                    success: clientAndUserReady,
                    message: clientAndUserReady ? 'Client and user are both ready.' : 'Client or user did not become ready.',
                };
            });
        }
        else {
            logger$2.warn('Unable to resolve datafile and user information because Optimizely client failed to initialize.');
            this.clientAndUserReadyPromise = new Promise(function (resolve) {
                resolve({
                    success: false,
                    reason: NotReadyReason.NO_CLIENT,
                    message: 'Optimizely client failed to initialize.',
                });
            });
        }
    }
    OptimizelyReactSDKClient.prototype.getUserWithOverrides = function (overrideUserId, overrideAttributes) {
        var id = overrideUserId === undefined ? this.user.id : overrideUserId;
        var attributes = overrideAttributes === undefined ? this.user.attributes : overrideAttributes;
        return {
            id: id,
            attributes: attributes,
        };
    };
    OptimizelyReactSDKClient.prototype.getIsReadyPromiseFulfilled = function () {
        return this.clientAndUserReadyPromiseFulfilled;
    };
    OptimizelyReactSDKClient.prototype.getIsUsingSdkKey = function () {
        return this.isUsingSdkKey;
    };
    Object.defineProperty(OptimizelyReactSDKClient.prototype, "odpExplicitlyOff", {
        get: function () {
            var _a;
            return (_a = this.initialConfig.odpOptions) === null || _a === void 0 ? void 0 : _a.disabled;
        },
        enumerable: false,
        configurable: true
    });
    OptimizelyReactSDKClient.prototype.onReady = function (config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var timeoutId;
        var timeout = DEFAULT_ON_READY_TIMEOUT;
        if (config && config.timeout !== undefined) {
            timeout = config.timeout;
        }
        var timeoutPromise = new Promise(function (resolve) {
            timeoutId = setTimeout(function () {
                resolve({
                    success: false,
                    reason: NotReadyReason.TIMEOUT,
                    message: 'Failed to initialize before timeout',
                    dataReadyPromise: _this.clientAndUserReadyPromise,
                });
            }, timeout);
        });
        return Promise.race([this.clientAndUserReadyPromise, timeoutPromise]).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                clearTimeout(timeoutId);
                return [2 /*return*/, res];
            });
        }); });
    };
    OptimizelyReactSDKClient.prototype.getUserContext = function () {
        if (!this._client) {
            logger$2.warn('Unable to get user context. Optimizely client not initialized.');
            return null;
        }
        if (!this.userContext) {
            logger$2.warn('Unable to get user context. User context not set.');
            return null;
        }
        return this.userContext;
    };
    OptimizelyReactSDKClient.prototype.setCurrentUserContext = function (userInfo) {
        if (!this._client) {
            logger$2.warn("Unable to set user context for user ID ".concat(userInfo.id, ". Optimizely client not initialized."));
            return;
        }
        if (!this.userContext) {
            this.userContext = this._client.createUserContext(userInfo.id || undefined, userInfo.attributes);
            return;
        }
        var currentUserContextUserInfo = {
            id: this.userContext.getUserId(),
            attributes: this.userContext.getAttributes(),
        };
        if (!areUsersEqual(userInfo, currentUserContextUserInfo)) {
            this.userContext = this._client.createUserContext(userInfo.id || undefined, userInfo.attributes);
        }
    };
    OptimizelyReactSDKClient.prototype.makeUserContextInstance = function (userInfo) {
        if (!this._client) {
            logger$2.warn("Unable to create user context for ".concat(userInfo.id, ". Optimizely client failed to initialize or not ready."));
            return null;
        }
        if (this.userContext && areUsersEqual(userInfo, this.user)) {
            // Important: We need to return the existing user context instance if the user info is the same
            // new context misses the forced variation set on the existing context
            return this.userContext;
        }
        return this._client.createUserContext(userInfo.id || undefined, userInfo.attributes);
    };
    OptimizelyReactSDKClient.prototype.fetchQualifiedSegments = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.userContext) {
                            return [2 /*return*/, false];
                        }
                        if (this.odpExplicitlyOff || !((_a = this._client) === null || _a === void 0 ? void 0 : _a.isOdpIntegrated())) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.userContext.fetchQualifiedSegments(options)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    OptimizelyReactSDKClient.prototype.setUser = function (userInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchQualifedSegmentsSucceed;
            var _this = this;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.user = {
                            id: userInfo.id || DefaultUser.id,
                            attributes: userInfo.attributes || DefaultUser.attributes,
                        };
                        if (!(userInfo.id === DefaultUser.id)) return [3 /*break*/, 2];
                        // wait for the SDK client to be ready before...
                        return [4 /*yield*/, ((_a = this._client) === null || _a === void 0 ? void 0 : _a.onReady())];
                    case 1:
                        // wait for the SDK client to be ready before...
                        _d.sent();
                        // setting the user context
                        this.setCurrentUserContext(userInfo);
                        // (potentially) retrieve the VUID set in JS userContext or noop or to DefaultUser
                        this.user.id = ((_b = this.userContext) === null || _b === void 0 ? void 0 : _b.getUserId()) || DefaultUser.id;
                        return [3 /*break*/, 4];
                    case 2:
                        // synchronous user context setting is required including for server side rendering (SSR)
                        this.setCurrentUserContext(userInfo);
                        // we need to wait for fetch qualified segments success for failure
                        return [4 /*yield*/, ((_c = this._client) === null || _c === void 0 ? void 0 : _c.onReady())];
                    case 3:
                        // we need to wait for fetch qualified segments success for failure
                        _d.sent();
                        _d.label = 4;
                    case 4: return [4 /*yield*/, this.fetchQualifiedSegments()];
                    case 5:
                        fetchQualifedSegmentsSucceed = _d.sent();
                        if (!this.isUserPromiseResolved) {
                            this.userPromiseResolver({ success: fetchQualifedSegmentsSucceed });
                            this.isUserPromiseResolved = true;
                        }
                        this.onUserUpdateHandlers.forEach(function (handler) { return handler(_this.user); });
                        return [2 /*return*/];
                }
            });
        });
    };
    OptimizelyReactSDKClient.prototype.onUserUpdate = function (handler) {
        var _this = this;
        this.onUserUpdateHandlers.push(handler);
        return function () {
            var ind = _this.onUserUpdateHandlers.indexOf(handler);
            if (ind > -1) {
                _this.onUserUpdateHandlers.splice(ind, 1);
            }
        };
    };
    /**
     * Register a handler to be called whenever setForcedVariation is called on
     * this client. Returns a function that un-registers the handler when called.
     * @param {OnForcedVariationsUpdateHandler} handler
     * @returns {DisposeFn}
     */
    OptimizelyReactSDKClient.prototype.onForcedVariationsUpdate = function (handler) {
        var _this = this;
        this.onForcedVariationsUpdateHandlers.push(handler);
        return function () {
            var ind = _this.onForcedVariationsUpdateHandlers.indexOf(handler);
            if (ind > -1) {
                _this.onForcedVariationsUpdateHandlers.splice(ind, 1);
            }
        };
    };
    OptimizelyReactSDKClient.prototype.isReady = function () {
        return this.isClientReady;
    };
    /**
     * Buckets visitor and sends impression event to Optimizely
     * @param {string} experimentKey
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.activate = function (experimentKey, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to activate experiment "%s" because Optimizely client failed to initialize.', experimentKey);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to activate experiment "%s" because User ID is not set', experimentKey);
            return null;
        }
        return this._client.activate(experimentKey, user.id, user.attributes);
    };
    OptimizelyReactSDKClient.prototype.decide = function (key, options, overrideUserId, overrideAttributes) {
        if (options === void 0) { options = []; }
        if (!this._client) {
            logger$2.warn('Unable to evaluate feature "%s" because Optimizely client failed to initialize.', key);
            return createFailedDecision(key, "Unable to evaluate flag ".concat(key, " because Optimizely client failed to initialize."), this.user);
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to evaluate feature "%s" because User ID is not set.', key);
            return createFailedDecision(key, "Unable to evaluate flag ".concat(key, " because User ID is not set."), user);
        }
        var optlyUserContext = this.makeUserContextInstance(user);
        if (optlyUserContext) {
            return __assign(__assign({}, optlyUserContext.decide(key, options)), { userContext: {
                    id: user.id,
                    attributes: user.attributes,
                } });
        }
        return createFailedDecision(key, "Not Evaluating flag ".concat(key, " because user id or attributes are not valid"), user);
    };
    OptimizelyReactSDKClient.prototype.decideForKeys = function (keys, options, overrideUserId, overrideAttributes) {
        if (options === void 0) { options = []; }
        if (!this._client) {
            logger$2.warn('Unable to evaluate features for keys because Optimizely client failed to initialize.');
            return {};
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to evaluate features for keys because User ID is not set');
            return {};
        }
        var optlyUserContext = this.makeUserContextInstance(user);
        if (optlyUserContext) {
            return Object.entries(optlyUserContext.decideForKeys(keys, options)).reduce(function (decisions, _a) {
                var key = _a[0], decision = _a[1];
                decisions[key] = __assign(__assign({}, decision), { userContext: {
                        id: user.id || '',
                        attributes: user.attributes,
                    } });
                return decisions;
            }, {});
        }
        return {};
    };
    OptimizelyReactSDKClient.prototype.decideAll = function (options, overrideUserId, overrideAttributes) {
        if (options === void 0) { options = []; }
        if (!this._client) {
            logger$2.warn('Unable to evaluate all feature decisions because Optimizely client is not initialized.');
            return {};
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to evaluate all feature decisions because User ID is not set');
            return {};
        }
        var optlyUserContext = this.makeUserContextInstance(user);
        if (optlyUserContext) {
            return Object.entries(optlyUserContext.decideAll(options)).reduce(function (decisions, _a) {
                var key = _a[0], decision = _a[1];
                decisions[key] = __assign(__assign({}, decision), { userContext: {
                        id: user.id || '',
                        attributes: user.attributes,
                    } });
                return decisions;
            }, {});
        }
        return {};
    };
    /**
     * Gets variation where visitor will be bucketed
     * @param {string} experimentKey
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getVariation = function (experimentKey, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get variation for experiment "%s" because Optimizely client failed to initialize.', experimentKey);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get variation for experiment "%s" because User ID is not set', experimentKey);
            return null;
        }
        return this._client.getVariation(experimentKey, user.id, user.attributes);
    };
    /**
     * Sends conversion event to Optimizely
     * @param {string} eventKey
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @param {optimizely.EventTags} [eventTags]
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.track = function (eventKey, overrideUserId, overrideAttributes, eventTags) {
        if (!this._client) {
            logger$2.warn('Unable to send tracking event "%s" because Optimizely client failed to initialize.', eventKey);
            return;
        }
        if (typeof overrideUserId !== 'undefined' && typeof overrideUserId !== 'string') {
            eventTags = overrideUserId;
            overrideUserId = undefined;
            overrideAttributes = undefined;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to send tracking event "%s" because User ID is not set', eventKey);
            return;
        }
        this._client.track(eventKey, user.id, user.attributes, eventTags);
    };
    /**
     * Sets the forced decision for specified optimizely decision context.
     * @param {optimizely.OptimizelyDecisionContext} decisionContext
     * @param {optimizely.OptimizelyForcedDecision} forcedDecision
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.setForcedDecision = function (decisionContext, decision) {
        if (!this.userContext) {
            logger$2.warn('Unable to set a forced decision because the user context has not been set yet.');
            return;
        }
        var isSuccess = this.userContext.setForcedDecision(decisionContext, decision);
        if (isSuccess) {
            this.forcedDecisionFlagKeys.add(decisionContext.flagKey);
            notifier.notify(decisionContext.flagKey);
        }
    };
    /**
     * Returns the forced decision for specified optimizely decision context.
     * @param {optimizely.OptimizelyDecisionContext} decisionContext
     * @return {(optimizely.OptimizelyForcedDecision | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getForcedDecision = function (decisionContext) {
        if (!this.userContext) {
            logger$2.warn('Unable to get a forced decision because the user context has not been set yet.');
            return null;
        }
        return this.userContext.getForcedDecision(decisionContext);
    };
    /**
     * Removes the forced decision for specified optimizely decision context.
     * @param {optimizely.OptimizelyDecisionContext} decisionContext
     * @return {boolean}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.removeForcedDecision = function (decisionContext) {
        if (!this.userContext) {
            logger$2.warn('Unable to remove forced decisions because the user context has not been set yet.');
            return false;
        }
        var isSuccess = this.userContext.removeForcedDecision(decisionContext);
        if (isSuccess) {
            this.forcedDecisionFlagKeys.delete(decisionContext.flagKey);
            notifier.notify(decisionContext.flagKey);
        }
        return isSuccess;
    };
    /**
     * Removes all the forced decision.
     * @return {boolean}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.removeAllForcedDecisions = function () {
        if (!this.userContext) {
            logger$2.warn('Unable to remove all forced decisions because the user context has not been set yet.');
            return false;
        }
        var isSuccess = this.userContext.removeAllForcedDecisions();
        if (isSuccess) {
            this.forcedDecisionFlagKeys.forEach(function (flagKey) { return notifier.notify(flagKey); });
            this.forcedDecisionFlagKeys.clear();
        }
        return isSuccess;
    };
    /**
     * Returns true if the feature is enabled for the given user
     * @param {string} feature
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {boolean}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.isFeatureEnabled = function (feature, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to determine if feature "%s" is enabled because Optimizely client failed to initialize.', feature);
            return false;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to determine if feature "%s" is enabled because User ID is not set', feature);
            return false;
        }
        return this._client.isFeatureEnabled(feature, user.id, user.attributes);
    };
    /**
     * @deprecated since 2.1.0
     * getAllFeatureVariables is added in JavaScript SDK which is similarly returning all the feature variables, but
     * it sends only single notification of type "all-feature-variables" instead of sending for each variable.
     * As getFeatureVariables was added when this functionality wasn't provided by JavaScript SDK, so there is no
     * need of it now and it would be removed in next major release
     *
     * Get all variables for a feature, regardless of the feature being enabled/disabled
     * @param {string} featureKey
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {VariableValuesObject}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariables = function (featureKey, overrideUserId, overrideAttributes) {
        var _this = this;
        if (!this._client) {
            logger$2.warn('Unable to get feature variables for feature "%s" because Optimizely client failed to initialize.', featureKey);
            return {};
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        var userId = user.id;
        if (userId === null) {
            logger$2.warn('Unable to get feature variables for feature "%s" because User ID is not set', featureKey);
            return {};
        }
        var userAttributes = user.attributes;
        var variableObj = {};
        var optlyConfig = this._client.getOptimizelyConfig();
        if (!optlyConfig) {
            logger$2.warn('Unable to retrieve feature variables for feature "%s" because Optimizely client failed to initialize.', featureKey);
            return {};
        }
        var feature = optlyConfig.featuresMap[featureKey];
        if (!feature) {
            logger$2.info('Unable to retrieve feature variables for feature "%s" because config features map is not set', featureKey);
            return {};
        }
        Object.keys(feature.variablesMap).forEach(function (key) {
            var variable = feature.variablesMap[key];
            variableObj[variable.key] = _this._client.getFeatureVariable(featureKey, variable.key, userId, userAttributes);
        });
        return variableObj;
    };
    /**
     * Returns value for the given string variable attached to the given feature
     * flag
     * @param {string} feature
     * @param {string} variable
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariableString = function (feature, variable, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable string from feature "%s" because Optimizely client failed to initialize.', feature);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable string from feature "%s" because User ID is not set', feature);
            return null;
        }
        return this._client.getFeatureVariableString(feature, variable, user.id, user.attributes);
    };
    /**
     * Returns value for the given boolean variable attached to the given feature
     * flag
     * @param {string} feature
     * @param {string} variable
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariableBoolean = function (feature, variable, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable boolean from feature "%s" because Optimizely client failed to initialize.', feature);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable boolean from feature "%s" because User ID is not set', feature);
            return null;
        }
        return this._client.getFeatureVariableBoolean(feature, variable, user.id, user.attributes);
    };
    /**
     * Returns value for the given integer variable attached to the given feature
     * flag
     * @param {string} feature
     * @param {string} variable
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariableInteger = function (feature, variable, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable integer from feature "%s" because Optimizely client failed to initialize.', feature);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable integer from feature "%s" because User ID is not set', feature);
            return null;
        }
        return this._client.getFeatureVariableInteger(feature, variable, user.id, user.attributes);
    };
    /**
     * Returns value for the given double variable attached to the given feature
     * flag
     * @param {string} feature
     * @param {string} variable
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariableDouble = function (feature, variable, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable double from feature "%s" because Optimizely client failed to initialize.', feature);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable double from feature "%s" because User ID is not set', feature);
            return null;
        }
        return this._client.getFeatureVariableDouble(feature, variable, user.id, user.attributes);
    };
    /**
     * Returns value for the given json variable attached to the given feature
     * flag
     * @param {string} feature
     * @param {string} variable
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(unknown | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariableJSON = function (feature, variable, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable JSON from feature "%s" because Optimizely client failed to initialize.', feature);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable JSON from feature "%s" because User ID is not set', feature);
            return null;
        }
        return this._client.getFeatureVariableJSON(feature, variable, user.id, user.attributes);
    };
    /**
     * Returns dynamically-typed value of the variable attached to the given
     * feature flag. Returns null if the feature key or variable key is invalid.
     * @param {string} featureKey
     * @param {string} variableKey
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {(FeatureVariableValue | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getFeatureVariable = function (featureKey, variableKey, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get feature variable from feature "%s" because Optimizely client failed to initialize.', featureKey, variableKey);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get feature variable from feature "%s" because User ID is not set', featureKey, variableKey);
            return null;
        }
        return this._client.getFeatureVariable(featureKey, variableKey, user.id, user.attributes);
    };
    /**
     * Returns values for all the variables attached to the given feature flag
     * @param {string} featureKey
     * @param {string} overrideUserId
     * @param {optimizely.UserAttributes} [overrideAttributes]
     * @returns {({ [variableKey: string]: unknown } | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getAllFeatureVariables = function (featureKey, overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get all feature variables from feature "%s" because Optimizely client failed to initialize.', featureKey);
            return {};
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get all feature variables from feature "%s" because User ID is not set', featureKey);
            return {};
        }
        return this._client.getAllFeatureVariables(featureKey, user.id, user.attributes);
    };
    /**
     * Get an array of all enabled features
     * @param {string} [overrideUserId]
     * @param {optimizely.UserAttributes} [overrideUserId]
     * @returns {Array<string>}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getEnabledFeatures = function (overrideUserId, overrideAttributes) {
        if (!this._client) {
            logger$2.warn('Unable to get list of enabled features because Optimizely client failed to initialize.');
            return [];
        }
        var user = this.getUserWithOverrides(overrideUserId, overrideAttributes);
        if (user.id === null) {
            logger$2.info('Unable to get list of enabled features because User ID is not set');
            return [];
        }
        return this._client.getEnabledFeatures(user.id, user.attributes);
    };
    /**
     * Gets the forced variation for a given user and experiment
     * @param {string} experiment
     * @param {string} [overrideUserId]
     * @returns {(string | null)}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.getForcedVariation = function (experiment, overrideUserId) {
        if (!this._client) {
            logger$2.warn('Unable to get forced variation for experiment "%s" because Optimizely client failed to initialize.', experiment);
            return null;
        }
        var user = this.getUserWithOverrides(overrideUserId);
        if (user.id === null) {
            logger$2.info('Unable to get forced variation for experiment "%s" because User ID is not set', experiment);
            return null;
        }
        return this._client.getForcedVariation(experiment, user.id);
    };
    /**
     * Force a user into a variation for a given experiment
     * @param {string} experiment
     * @param {string} overrideUserIdOrVariationKey
     * @param {string} [variationKey]
     * @returns {boolean}
     * @memberof OptimizelyReactSDKClient
     */
    OptimizelyReactSDKClient.prototype.setForcedVariation = function (experiment, overrideUserIdOrVariationKey, variationKey) {
        if (!this._client) {
            logger$2.warn('Unable to set forced variation for experiment "%s" because Optimizely client failed to initialize.', experiment);
            return false;
        }
        var finalUserId = null;
        var finalVariationKey = null;
        if (arguments.length === 2) {
            finalVariationKey = overrideUserIdOrVariationKey;
            finalUserId = this.getUserWithOverrides().id;
        }
        else if (arguments.length === 3) {
            finalUserId = this.getUserWithOverrides(overrideUserIdOrVariationKey).id;
            if (variationKey === undefined) {
                // can't have undefined if supplying all 3 arguments
                return false;
            }
            finalVariationKey = variationKey;
        }
        if (finalUserId === null) {
            logger$2.warn('Unable to set forced variation for experiment "%s" because User ID is not set', experiment);
            return false;
        }
        var result = this._client.setForcedVariation(experiment, finalUserId, finalVariationKey);
        this.onForcedVariationsUpdateHandlers.forEach(function (handler) { return handler(); });
        return result;
    };
    /**
     *  Returns OptimizelyConfig object containing experiments and features data
     *  @returns {optimizely.OptimizelyConfig | null} optimizely config
     */
    OptimizelyReactSDKClient.prototype.getOptimizelyConfig = function () {
        if (!this._client) {
            logger$2.warn('Unable to get Optimizely configuration because Optimizely client failed to initialize.');
            return null;
        }
        return this._client.getOptimizelyConfig();
    };
    /**
     * Cleanup method for killing an running timers and flushing eventQueue
     * @returns {Promise<{ success: boolean; reason?: string }>}
     */
    OptimizelyReactSDKClient.prototype.close = function () {
        if (!this._client) {
            /**
             * Note:
             * - Returns a promise that resolves as "true" even when this._client does not exist.
             * - This is because cleanup relies on close() resolving as "true".
             * - If we resolve as "false", then the cleanup for timers and the event queue will never trigger.
             * - Not triggering cleanup may lead to memory leaks and other inefficiencies.
             */
            return new Promise(function (resolve, reject) {
                return resolve({
                    success: true,
                    reason: 'Optimizely client is not initialized.',
                });
            });
        }
        return this._client.close();
    };
    Object.defineProperty(OptimizelyReactSDKClient.prototype, "client", {
        /**
         * Provide access to inner optimizely.Client object
         */
        get: function () {
            if (!this._client) {
                logger$2.warn('Unable to get client because Optimizely client failed to initialize.');
                return null;
            }
            return this._client;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptimizelyReactSDKClient.prototype, "notificationCenter", {
        get: function () {
            if (!this._client) {
                return {
                    addNotificationListener: function () {
                        logger$2.warn('Unable to add notification listener because Optimizely client failed to initialize.');
                        return 0;
                    },
                    removeNotificationListener: function () {
                        logger$2.warn('Unable to remove notification listener because Optimizely client failed to initialize.');
                        return false;
                    },
                    clearAllNotificationListeners: function () {
                        logger$2.warn('Unable to clear all notification listeners because Optimizely client failed to initialize.');
                    },
                    clearNotificationListeners: function () {
                        logger$2.warn('Unable to clear notification listeners because Optimizely client failed to initialize.');
                    },
                };
            }
            return this._client.notificationCenter;
        },
        enumerable: false,
        configurable: true
    });
    OptimizelyReactSDKClient.prototype.sendOdpEvent = function (action, type, identifiers, data) {
        var _a;
        if (!action || !action.trim()) {
            logger$2.error('ODP action is not valid (cannot be empty).');
            return;
        }
        (_a = this.client) === null || _a === void 0 ? void 0 : _a.sendOdpEvent(action, type, identifiers, data);
    };
    OptimizelyReactSDKClient.prototype.getVuid = function () {
        if (!this._client) {
            logger$2.warn('Unable to get VUID because Optimizely client failed to initialize.');
            return undefined;
        }
        return this._client.getVuid();
    };
    return OptimizelyReactSDKClient;
}());
function createInstance(config) {
    return new OptimizelyReactSDKClient(config);
}

/**
 * Copyright 2022-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger$1 = optimizely.getLogger('<OptimizelyProvider>');
var OptimizelyProvider = /** @class */ (function (_super) {
    __extends(OptimizelyProvider, _super);
    function OptimizelyProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.setUserInOptimizely();
        return _this;
    }
    OptimizelyProvider.prototype.setUserInOptimizely = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, optimizely, userId, userAttributes, user, finalUser;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, optimizely = _a.optimizely, userId = _a.userId, userAttributes = _a.userAttributes, user = _a.user;
                        if (!optimizely) {
                            logger$1.error('OptimizelyProvider must be passed an instance of the Optimizely SDK client');
                            return [2 /*return*/];
                        }
                        finalUser = null;
                        if (user) {
                            if ('then' in user) {
                                user.then(function (res) {
                                    optimizely.setUser(res);
                                });
                            }
                            else {
                                finalUser = {
                                    id: user.id,
                                    attributes: user.attributes || {},
                                };
                            }
                        }
                        else if (userId) {
                            finalUser = {
                                id: userId,
                                attributes: userAttributes || {},
                            };
                            // deprecation warning
                            logger$1.warn('Passing userId and userAttributes as props is deprecated, please switch to using `user` prop');
                        }
                        else {
                            finalUser = {
                                id: DefaultUser.id,
                                attributes: userAttributes || DefaultUser.attributes,
                            };
                        }
                        if (!finalUser) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, optimizely.setUser(finalUser)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _c.sent();
                        logger$1.error('Error while trying to set user.');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OptimizelyProvider.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isServerSide) {
            // dont react to updates on server
            return;
        }
        var optimizely = this.props.optimizely;
        if (this.props.user && 'id' in this.props.user) {
            if (!optimizely.user.id) {
                // no user is set in optimizely, update
                optimizely.setUser(this.props.user);
            }
            else if (
            // if the users aren't equal update
            !areUsersEqual({
                id: optimizely.user.id,
                attributes: optimizely.user.attributes || {},
            }, {
                id: this.props.user.id,
                // TODO see if we can use computeDerivedStateFromProps
                attributes: this.props.user.attributes || {},
            })) {
                optimizely.setUser(this.props.user);
            }
        }
    };
    OptimizelyProvider.prototype.render = function () {
        var _a = this.props, optimizely = _a.optimizely, children = _a.children, timeout = _a.timeout;
        var isServerSide = !!this.props.isServerSide;
        var value = {
            optimizely: optimizely,
            isServerSide: isServerSide,
            timeout: timeout,
        };
        return React__namespace.createElement(OptimizelyContextProvider, { value: value }, children);
    };
    return OptimizelyProvider;
}(React__namespace.Component));

/**
 * Copyright 2020, 2023 Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Utility to setup listeners for changes to the datafile or user attributes and invoke the provided callback.
 * Returns an unListen function
 */
var setupAutoUpdateListeners = function (optimizely$1, type, value, logger, callback) {
    var loggerSuffix = "re-evaluating ".concat(type, "=\"").concat(value, "\" for user=\"").concat(optimizely$1.user.id, "\"");
    var optimizelyNotificationId = optimizely$1.notificationCenter.addNotificationListener(optimizely.enums.NOTIFICATION_TYPES.OPTIMIZELY_CONFIG_UPDATE, function () {
        logger.info("".concat(optimizely.enums.NOTIFICATION_TYPES.OPTIMIZELY_CONFIG_UPDATE, ", ").concat(loggerSuffix));
        callback();
    });
    var unregisterConfigUpdateListener = function () {
        return optimizely$1.notificationCenter.removeNotificationListener(optimizelyNotificationId);
    };
    var unregisterUserListener = optimizely$1.onUserUpdate(function () {
        logger.info("User update, ".concat(loggerSuffix));
        callback();
    });
    return function () {
        unregisterConfigUpdateListener();
        unregisterUserListener();
    };
};

/**
 * Copyright 2018-2019, 2022-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var hooksLogger = optimizely.getLogger('ReactSDK');
var optimizelyPropError = "The 'optimizely' prop must be supplied via a parent <OptimizelyProvider>";
var HookType;
(function (HookType) {
    HookType["EXPERIMENT"] = "Experiment";
    HookType["FEATURE"] = "Feature";
})(HookType || (HookType = {}));
/**
 * Equality check applied to decision inputs passed into hooks (experiment/feature keys, override user IDs, and override user attributes).
 * Used to determine when we need to recompute a decision because different inputs were passed into a hook.
 * @param {DecisionInputs} oldDecisionInputs
 * @param {DecisionInput} newDecisionInputs
 * @returns boolean
 */
function areDecisionInputsEqual(oldDecisionInputs, newDecisionInputs) {
    return (oldDecisionInputs.entityKey === newDecisionInputs.entityKey &&
        oldDecisionInputs.overrideUserId === newDecisionInputs.overrideUserId &&
        areAttributesEqual(oldDecisionInputs.overrideAttributes, newDecisionInputs.overrideAttributes));
}
/**
 * Subscribe to changes in initialization state of the argument client. onInitStateChange callback
 * is called on the following events:
 * - optimizely successfully becomes ready
 * - timeout is reached prior to optimizely becoming ready
 * - optimizely becomes ready after the timeout has already passed
 * @param {ReactSDKClient} optimizely
 * @param {number|undefined} timeout
 * @param {Function} onInitStateChange
 */
function subscribeToInitialization(optimizely, timeout, onInitStateChange) {
    optimizely
        .onReady({ timeout: timeout })
        .then(function (res) {
        var _a, _b, _c, _d;
        if (res.success) {
            hooksLogger.info('Client immediately ready');
            onInitStateChange({
                clientReady: true,
                didTimeout: false,
            });
            return;
        }
        switch (res.reason) {
            // Optimizely client failed to initialize.
            case NotReadyReason.NO_CLIENT:
                hooksLogger.warn("Client not ready, reason=\"".concat(res.message, "\""));
                onInitStateChange({
                    clientReady: false,
                    didTimeout: false,
                });
                (_a = res.dataReadyPromise) === null || _a === void 0 ? void 0 : _a.then(function (readyResult) {
                    if (!readyResult) {
                        return;
                    }
                    var success = readyResult.success, message = readyResult.message;
                    if (success) {
                        hooksLogger.info('Client became ready.');
                    }
                    else {
                        hooksLogger.warn("Client not ready, reason=\"".concat(message, "\""));
                    }
                    onInitStateChange({
                        clientReady: success,
                        didTimeout: false,
                    });
                });
                break;
            case NotReadyReason.USER_NOT_READY:
                hooksLogger.warn("User was not ready, reason=\"".concat(res.message, "\""));
                onInitStateChange({
                    clientReady: false,
                    didTimeout: false,
                });
                (_b = res.dataReadyPromise) === null || _b === void 0 ? void 0 : _b.then(function (readyResult) {
                    if (!readyResult) {
                        return;
                    }
                    var success = readyResult.success, message = readyResult.message;
                    if (success) {
                        hooksLogger.info('User became ready later.');
                    }
                    else {
                        hooksLogger.warn("Client not ready, reason=\"".concat(message, "\""));
                    }
                    onInitStateChange({
                        clientReady: success,
                        didTimeout: false,
                    });
                });
                break;
            case NotReadyReason.TIMEOUT:
                hooksLogger.info("Client did not become ready before timeout of ".concat(timeout, " ms, reason=\"").concat(res.message, "\""));
                onInitStateChange({
                    clientReady: false,
                    didTimeout: true,
                });
                (_c = res.dataReadyPromise) === null || _c === void 0 ? void 0 : _c.then(function (readyResult) {
                    if (!readyResult) {
                        return;
                    }
                    var success = readyResult.success, message = readyResult.message;
                    if (success) {
                        hooksLogger.info('Client became ready after timeout already elapsed');
                    }
                    else {
                        hooksLogger.warn("Client not ready, reason=\"".concat(message, "\""));
                    }
                    onInitStateChange({
                        clientReady: success,
                        didTimeout: true,
                    });
                });
                break;
            default:
                hooksLogger.warn("Other reason client not ready, reason=\"".concat(res.message, "\""));
                onInitStateChange({
                    clientReady: false,
                    didTimeout: false,
                });
                (_d = res.dataReadyPromise) === null || _d === void 0 ? void 0 : _d.then(function (readyResult) {
                    if (!readyResult) {
                        return;
                    }
                    var success = readyResult.success, message = readyResult.message;
                    if (success) {
                        hooksLogger.info('Client became ready later');
                    }
                    else {
                        hooksLogger.warn("Client not ready, reason=\"".concat(message, "\""));
                    }
                    onInitStateChange({
                        clientReady: success,
                        didTimeout: false,
                    });
                });
        }
    })
        .catch(function () {
        hooksLogger.error("Error initializing client. The core client or user promise(s) rejected.");
    });
}
function useCompareAttrsMemoize(value) {
    var ref = React.useRef();
    if (!areAttributesEqual(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
/**
 * A React Hook that retrieves the variation for an experiment, optionally
 * auto updating that value based on underlying user or datafile changes.
 *
 * Note: The react client can become ready AFTER the timeout period.
 *       ClientReady and DidTimeout provide signals to handle this scenario.
 */
var useExperiment = function (experimentKey, options, overrides) {
    if (options === void 0) { options = {}; }
    if (overrides === void 0) { overrides = {}; }
    var _a = React.useContext(OptimizelyContext), optimizely = _a.optimizely, isServerSide = _a.isServerSide, timeout = _a.timeout;
    var overrideAttrs = useCompareAttrsMemoize(overrides.overrideAttributes);
    var getCurrentDecision = React.useCallback(function () { return ({
        variation: (optimizely === null || optimizely === void 0 ? void 0 : optimizely.activate(experimentKey, overrides.overrideUserId, overrideAttrs)) || null,
    }); }, [optimizely, experimentKey, overrides.overrideUserId, overrideAttrs]);
    var isClientReady = isServerSide || !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.isReady());
    var isReadyPromiseFulfilled = !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.getIsReadyPromiseFulfilled());
    var _b = React.useState(function () {
        var decisionState = isClientReady ? getCurrentDecision() : { variation: null };
        return __assign(__assign({}, decisionState), { clientReady: isClientReady, didTimeout: false });
    }), state = _b[0], setState = _b[1];
    // Decision state is derived from entityKey and overrides arguments.
    // Track the previous value of those arguments, and update state when they change.
    // This is an instance of the derived state pattern recommended here:
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var currentDecisionInputs = {
        entityKey: experimentKey,
        overrideUserId: overrides.overrideUserId,
        overrideAttributes: overrideAttrs,
    };
    var _c = React.useState(currentDecisionInputs), prevDecisionInputs = _c[0], setPrevDecisionInputs = _c[1];
    if (!areDecisionInputsEqual(prevDecisionInputs, currentDecisionInputs)) {
        setPrevDecisionInputs(currentDecisionInputs);
        setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
    }
    var finalReadyTimeout = options.timeout !== undefined ? options.timeout : timeout;
    React.useEffect(function () {
        // Subscribe to initialzation promise only
        // 1. When client is using Sdk Key, which means the initialization will be asynchronous
        //    and we need to wait for the promise and update decision.
        // 2. When client is using datafile only but client is not ready yet which means user
        //    was provided as a promise and we need to subscribe and wait for user to become available.
        if (optimizely && ((optimizely.getIsUsingSdkKey() && !isReadyPromiseFulfilled) || !isClientReady)) {
            subscribeToInitialization(optimizely, finalReadyTimeout, function (initState) {
                setState(__assign(__assign({}, getCurrentDecision()), initState));
            });
        }
    }, [finalReadyTimeout, getCurrentDecision, isClientReady, isReadyPromiseFulfilled, optimizely]);
    React.useEffect(function () {
        // Subscribe to update after first datafile is fetched and readyPromise is resolved to avoid redundant rendering.
        if (optimizely && isReadyPromiseFulfilled && options.autoUpdate) {
            return setupAutoUpdateListeners(optimizely, HookType.EXPERIMENT, experimentKey, hooksLogger, function () {
                setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
            });
        }
        return function () { };
    }, [isReadyPromiseFulfilled, options.autoUpdate, optimizely, experimentKey, getCurrentDecision]);
    React.useEffect(function () {
        return optimizely === null || optimizely === void 0 ? void 0 : optimizely.onForcedVariationsUpdate(function () {
            setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
        });
    }, [getCurrentDecision, optimizely]);
    if (!optimizely) {
        hooksLogger.error("Unable to use experiment ".concat(experimentKey, ". ").concat(optimizelyPropError));
    }
    return [state.variation, state.clientReady, state.didTimeout];
};
/**
 * A React Hook that retrieves the status of a feature flag and its variables, optionally
 * auto updating those values based on underlying user or datafile changes.
 *
 * Note: The react client can become ready AFTER the timeout period.
 *       ClientReady and DidTimeout provide signals to handle this scenario.
 */
var useFeature = function (featureKey, options, overrides) {
    if (options === void 0) { options = {}; }
    if (overrides === void 0) { overrides = {}; }
    var _a = React.useContext(OptimizelyContext), optimizely = _a.optimizely, isServerSide = _a.isServerSide, timeout = _a.timeout;
    var overrideAttrs = useCompareAttrsMemoize(overrides.overrideAttributes);
    var getCurrentDecision = React.useCallback(function () { return ({
        isEnabled: !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.isFeatureEnabled(featureKey, overrides.overrideUserId, overrideAttrs)),
        variables: (optimizely === null || optimizely === void 0 ? void 0 : optimizely.getFeatureVariables(featureKey, overrides.overrideUserId, overrideAttrs)) || {},
    }); }, [optimizely, featureKey, overrides.overrideUserId, overrideAttrs]);
    var isClientReady = isServerSide || !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.isReady());
    var isReadyPromiseFulfilled = !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.getIsReadyPromiseFulfilled());
    var _b = React.useState(function () {
        var decisionState = isClientReady ? getCurrentDecision() : { isEnabled: false, variables: {} };
        return __assign(__assign({}, decisionState), { clientReady: isClientReady, didTimeout: false });
    }), state = _b[0], setState = _b[1];
    // Decision state is derived from entityKey and overrides arguments.
    // Track the previous value of those arguments, and update state when they change.
    // This is an instance of the derived state pattern recommended here:
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var currentDecisionInputs = {
        entityKey: featureKey,
        overrideUserId: overrides.overrideUserId,
        overrideAttributes: overrides.overrideAttributes,
    };
    var _c = React.useState(currentDecisionInputs), prevDecisionInputs = _c[0], setPrevDecisionInputs = _c[1];
    if (!areDecisionInputsEqual(prevDecisionInputs, currentDecisionInputs)) {
        setPrevDecisionInputs(currentDecisionInputs);
        setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
    }
    var finalReadyTimeout = options.timeout !== undefined ? options.timeout : timeout;
    React.useEffect(function () {
        // Subscribe to initialzation promise only
        // 1. When client is using Sdk Key, which means the initialization will be asynchronous
        //    and we need to wait for the promise and update decision.
        // 2. When client is using datafile only but client is not ready yet which means user
        //    was provided as a promise and we need to subscribe and wait for user to become available.
        if (optimizely && (optimizely.getIsUsingSdkKey() || !isClientReady)) {
            subscribeToInitialization(optimizely, finalReadyTimeout, function (initState) {
                setState(__assign(__assign({}, getCurrentDecision()), initState));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalReadyTimeout, getCurrentDecision, optimizely]);
    React.useEffect(function () {
        // Subscribe to update after first datafile is fetched and readyPromise is resolved to avoid redundant rendering.
        if (optimizely && isReadyPromiseFulfilled && options.autoUpdate) {
            return setupAutoUpdateListeners(optimizely, HookType.FEATURE, featureKey, hooksLogger, function () {
                setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
            });
        }
        return function () { };
    }, [isReadyPromiseFulfilled, options.autoUpdate, optimizely, featureKey, getCurrentDecision]);
    if (!optimizely) {
        hooksLogger.error("Unable to properly use feature ".concat(featureKey, ". ").concat(optimizelyPropError));
    }
    return [state.isEnabled, state.variables, state.clientReady, state.didTimeout];
};
/**
 * A React Hook that retrieves the flag decision, optionally
 * auto updating those values based on underlying user or datafile changes.
 *
 * Note: The react client can become ready AFTER the timeout period.
 *       ClientReady and DidTimeout provide signals to handle this scenario.
 */
var useDecision = function (flagKey, options, overrides) {
    if (options === void 0) { options = {}; }
    if (overrides === void 0) { overrides = {}; }
    var _a = React.useContext(OptimizelyContext), optimizely = _a.optimizely, isServerSide = _a.isServerSide, timeout = _a.timeout;
    var overrideAttrs = useCompareAttrsMemoize(overrides.overrideAttributes);
    var defaultDecision = React.useMemo(function () {
        return createFailedDecision(flagKey, 'Optimizely SDK not configured properly yet.', {
            id: overrides.overrideUserId || null,
            attributes: overrideAttrs || {},
        });
    }, [flagKey, overrideAttrs, overrides.overrideUserId]);
    var getCurrentDecision = React.useCallback(function () { return ({
        decision: (optimizely === null || optimizely === void 0 ? void 0 : optimizely.decide(flagKey, options.decideOptions, overrides.overrideUserId, overrideAttrs)) || defaultDecision,
    }); }, [flagKey, defaultDecision, optimizely, options.decideOptions, overrideAttrs, overrides.overrideUserId]);
    var isClientReady = isServerSide || !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.isReady());
    var isReadyPromiseFulfilled = !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.getIsReadyPromiseFulfilled());
    var _b = React.useState(function () {
        var decisionState = isClientReady
            ? getCurrentDecision()
            : {
                decision: defaultDecision,
            };
        return __assign(__assign({}, decisionState), { clientReady: isClientReady, didTimeout: false });
    }), state = _b[0], setState = _b[1];
    // Decision state is derived from entityKey and overrides arguments.
    // Track the previous value of those arguments, and update state when they change.
    // This is an instance of the derived state pattern recommended here:
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var currentDecisionInputs = {
        entityKey: flagKey,
        overrideUserId: overrides.overrideUserId,
        overrideAttributes: overrides.overrideAttributes,
    };
    var _c = React.useState(currentDecisionInputs), prevDecisionInputs = _c[0], setPrevDecisionInputs = _c[1];
    if (!areDecisionInputsEqual(prevDecisionInputs, currentDecisionInputs)) {
        setPrevDecisionInputs(currentDecisionInputs);
        setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
    }
    var finalReadyTimeout = options.timeout !== undefined ? options.timeout : timeout;
    React.useEffect(function () {
        // Subscribe to initialzation promise only
        // 1. When client is using Sdk Key, which means the initialization will be asynchronous
        //    and we need to wait for the promise and update decision.
        // 2. When client is using datafile only but client is not ready yet which means user
        //    was provided as a promise and we need to subscribe and wait for user to become available.
        if (optimizely && (optimizely.getIsUsingSdkKey() || !isClientReady)) {
            subscribeToInitialization(optimizely, finalReadyTimeout, function (initState) {
                setState(__assign(__assign({}, getCurrentDecision()), initState));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalReadyTimeout, getCurrentDecision, optimizely]);
    React.useEffect(function () {
        if (overrides.overrideUserId || overrides.overrideAttributes || !options.autoUpdate) {
            return;
        }
        // Subscribe to Forced Decision changes.
        return notifier.subscribe(flagKey, function () {
            setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
        });
    }, [overrides.overrideUserId, overrides.overrideAttributes, options.autoUpdate, flagKey, getCurrentDecision]);
    React.useEffect(function () {
        // Subscribe to update after first datafile is fetched and readyPromise is resolved to avoid redundant rendering.
        if (optimizely && isReadyPromiseFulfilled && options.autoUpdate) {
            return setupAutoUpdateListeners(optimizely, HookType.FEATURE, flagKey, hooksLogger, function () {
                setState(function (prevState) { return (__assign(__assign({}, prevState), getCurrentDecision())); });
            });
        }
        return function () { };
    }, [isReadyPromiseFulfilled, options.autoUpdate, optimizely, flagKey, getCurrentDecision]);
    if (!optimizely) {
        hooksLogger.error("Unable to use decision ".concat(flagKey, ". ").concat(optimizelyPropError));
    }
    return [state.decision, state.clientReady, state.didTimeout];
};
var useTrackEvent = function () {
    var _a = React.useContext(OptimizelyContext), optimizely = _a.optimizely, isServerSide = _a.isServerSide, timeout = _a.timeout;
    var isClientReady = isServerSide || !!(optimizely === null || optimizely === void 0 ? void 0 : optimizely.isReady());
    var track = React.useCallback(function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        if (!optimizely) {
            hooksLogger.error("Unable to track events. ".concat(optimizelyPropError));
            return;
        }
        if (!isClientReady) {
            hooksLogger.error("Unable to track events. Optimizely client is not ready yet.");
            return;
        }
        optimizely.track.apply(optimizely, rest);
    }, [optimizely, isClientReady]);
    var _b = React.useState(function () {
        return {
            clientReady: isClientReady,
            didTimeout: false,
        };
    }), state = _b[0], setState = _b[1];
    React.useEffect(function () {
        // Subscribe to initialization promise only
        // 1. When client is using Sdk Key, which means the initialization will be asynchronous
        //    and we need to wait for the promise and update decision.
        // 2. When client is using datafile only but client is not ready yet which means user
        //    was provided as a promise and we need to subscribe and wait for user to become available.
        if (optimizely && (optimizely.getIsUsingSdkKey() || !isClientReady)) {
            subscribeToInitialization(optimizely, timeout, function (initState) {
                setState(initState);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [optimizely, timeout]);
    return [track, state.clientReady, state.didTimeout];
};

/**
 * Copyright 2018-2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FeatureComponent = function (props) {
    var feature = props.feature, timeout = props.timeout, autoUpdate = props.autoUpdate, children = props.children, overrideUserId = props.overrideUserId, overrideAttributes = props.overrideAttributes;
    var _a = useFeature(feature, { timeout: timeout, autoUpdate: autoUpdate }, { overrideUserId: overrideUserId, overrideAttributes: overrideAttributes }), isEnabled = _a[0], variables = _a[1], clientReady = _a[2], didTimeout = _a[3];
    if (!clientReady && !didTimeout) {
        // Only block rendering while were waiting for the client within the allowed timeout.
        return null;
    }
    // Wrap the return value here in a Fragment to please the HOC's expected React.ComponentType
    // See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return React__namespace.createElement(React__namespace.Fragment, null, children(isEnabled, variables, clientReady, didTimeout));
};
var OptimizelyFeature = FeatureComponent;

function withOptimizely(Component) {
    var WithOptimizely = /** @class */ (function (_super) {
        __extends(WithOptimizely, _super);
        function WithOptimizely() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithOptimizely.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            // Note: Casting props to P is necessary because of this TypeScript issue:
            // https://github.com/microsoft/TypeScript/issues/28884
            return (React__namespace.createElement(OptimizelyContextConsumer, null, function (value) { return (React__namespace.createElement(Component, __assign({}, rest, { optimizelyReadyTimeout: value.timeout, optimizely: value.optimizely, isServerSide: value.isServerSide, ref: forwardedRef }))); }));
        };
        return WithOptimizely;
    }(React__namespace.Component));
    var withRefsForwarded = hoistStaticsAndForwardRefs(WithOptimizely, Component, 'withOptimizely');
    return withRefsForwarded;
}

/**
 * Copyright 2018-2019, 2023-2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Experiment = function (props) {
    var experiment = props.experiment, autoUpdate = props.autoUpdate, timeout = props.timeout, overrideUserId = props.overrideUserId, overrideAttributes = props.overrideAttributes, children = props.children;
    var _a = useExperiment(experiment, { timeout: timeout, autoUpdate: autoUpdate }, { overrideUserId: overrideUserId, overrideAttributes: overrideAttributes }), variation = _a[0], clientReady = _a[1], didTimeout = _a[2];
    if (!clientReady && !didTimeout) {
        // Only block rendering while were waiting for the client within the allowed timeout.
        return null;
    }
    if (children != null && typeof children === 'function') {
        // Wrap the return value here in a Fragment to please the HOC's expected React.ComponentType
        // See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
        return React__namespace.createElement(React__namespace.Fragment, null, children(variation, clientReady, didTimeout));
    }
    var defaultMatch = null;
    var variationMatch = null;
    // We use React.Children.forEach instead of React.Children.toArray().find()
    // here because toArray adds keys to all child elements and we do not want
    // to trigger an unmount/remount
    React__namespace.Children.forEach(children, function (child) {
        if (!React__namespace.isValidElement(child)) {
            return;
        }
        if (child.props.variation) {
            if (variation === child.props.variation) {
                variationMatch = child;
            }
        }
        // Last child with default prop wins
        if (child.props.default) {
            defaultMatch = child;
        }
    });
    var match = null;
    if (variationMatch) {
        match = variationMatch;
    }
    else if (defaultMatch) {
        match = defaultMatch;
    }
    return match;
};
var OptimizelyExperiment = Experiment;

/**
 * Copyright 2018-2019, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Wrap the return value here in a Fragment to please the HOC's expected React.ComponentType
// See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
var Variation = function (_a) {
    var children = _a.children;
    return React__namespace.createElement(React__namespace.Fragment, null, children);
};
var OptimizelyVariation = Variation;

/**
 * Copyright 2019, 2023 Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = optimizely.getLogger('ReactSDK');
/**
 * logOnlyEventDispatcher only logs a message at the debug level, and does not
 * send any requests to the Optimizely results backend. Use this to disable
 * all event dispatching.
 */
var logOnlyEventDispatcher = {
    dispatchEvent: function (event, callback) {
        logger.debug('Event not dispatched by disabled event dispatcher: %s', function () {
            var eventStr;
            try {
                eventStr = JSON.stringify(event);
            }
            catch (err) {
                eventStr = 'error stringifying event';
            }
            return eventStr;
        });
        callback({ statusCode: 204 });
    },
};

Object.defineProperty(exports, 'OptimizelyDecideOption', {
  enumerable: true,
  get: function () { return optimizely.OptimizelyDecideOption; }
});
Object.defineProperty(exports, 'OptimizelySegmentOption', {
  enumerable: true,
  get: function () { return optimizely.OptimizelySegmentOption; }
});
Object.defineProperty(exports, 'enums', {
  enumerable: true,
  get: function () { return optimizely.enums; }
});
Object.defineProperty(exports, 'errorHandler', {
  enumerable: true,
  get: function () { return optimizely.errorHandler; }
});
Object.defineProperty(exports, 'eventDispatcher', {
  enumerable: true,
  get: function () { return optimizely.eventDispatcher; }
});
Object.defineProperty(exports, 'logging', {
  enumerable: true,
  get: function () { return optimizely.logging; }
});
Object.defineProperty(exports, 'setLogLevel', {
  enumerable: true,
  get: function () { return optimizely.setLogLevel; }
});
Object.defineProperty(exports, 'setLogger', {
  enumerable: true,
  get: function () { return optimizely.setLogger; }
});
exports.OptimizelyContext = OptimizelyContext;
exports.OptimizelyContextConsumer = OptimizelyContextConsumer;
exports.OptimizelyContextProvider = OptimizelyContextProvider;
exports.OptimizelyExperiment = OptimizelyExperiment;
exports.OptimizelyFeature = OptimizelyFeature;
exports.OptimizelyProvider = OptimizelyProvider;
exports.OptimizelyVariation = OptimizelyVariation;
exports.createInstance = createInstance;
exports.logOnlyEventDispatcher = logOnlyEventDispatcher;
exports.useDecision = useDecision;
exports.useExperiment = useExperiment;
exports.useFeature = useFeature;
exports.useTrackEvent = useTrackEvent;
exports.withOptimizely = withOptimizely;
